import Navbar from "../components/Navbar/Navbar";
import Hero from "../components/Hero/hero";
import travelImg from "../assets/service.jpg";
import Footer from "../components/Footer/Footer";
import Trip from "../components/BestPlaces/trip";

function Service () {
    return (
        <>
        <Navbar/>
         <Hero
         cName="hero-mid"
         heroImg={travelImg}
         title="Service"
         btnClass="hide"
         />
         <Trip/>
         <Footer/>
        </>
    )


}

export default Service;